import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    buildingYourRoutes: translate({ id: 'loader.buildingYourRoutes' }),
    optimizationInProgress: translate({ id: 'loader.optimizationInProgress' }),
    cancelOptimization: translate({ id: 'loader.cancelOptimization' }),
  }))

  return api
}
